// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 257 ? "59bfa46b" : chunkId) + "." + {"257":"52233f99c170b9c9","606":"ff57f867bc758bbf"}[chunkId] + ".js";
};